/**
 * A finished blend's read-only details (user, 2026-10-09): the Blended tab's View. A sibling of `$id`
 * (the trailing `_` keeps it from nesting inside the form), not a tab of it.
 */
import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { BlendDetailsPage } from "@/features/processing/components/blend-details-page";

export const Route = createFileRoute("/_app/processing/blending/$id_/details")({
  params: {
    parse: ({ id }) => {
      if (!/^\d+$/.test(id)) throw notFound();
      return { id };
    },
    stringify: (p) => p,
  },
  beforeLoad: () => {
    if (!useAuth.getState().can("document.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { id } = Route.useParams();
  return <BlendDetailsPage id={Number(id)} />;
}
